const authorizedUsersOnly = (to, from, next) => {
  const foundToken = localStorage.getItem("token");
  foundToken ? next() : next({ path: "/login" });
};

const anonymousUsersOnly = (to, from, next) => {
  const foundToken = localStorage.getItem("token");
  foundToken ? next({ path: "/" }) : next();
};

export const routerMiddleware = {
  authorizedUsersOnly,
  anonymousUsersOnly,
};



// WEBPACK FOOTER //
// ./src/_shared/middlewares/routerMiddleware.js